import React, {Component} from 'react'
import PropTypes from 'prop-types'

import 'video.js/dist/video-js.css'
import './video.styl'

//https://github.com/fluse/splitplayer
//https://www.jwplayer.com/blog/building-insights-video-experience/
class VideoForm extends Component {

    static propTypes = {
        className: PropTypes.string,
        video: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            type: "video/mp4",
            src: PropTypes.string.isRequired,
            poster: PropTypes.string
        }).isRequired
    }

    state = {}

    componentDidMount() {
        const {videojs} = global
        if (!videojs) {
            return
        }
        const {video} = this.props
        this.state.player = videojs(video.id)
    }

    componentWillUnmount() {
        if (this.state.player) {
            this.state.player.dispose()
        }
    }

    render() {
        const {video: {id = 0, src, poster}, className} = this.props
        return <video id={id} className={`${className} video-js vjs-default-skin`} controls preload="auto" poster={poster}>
            <source src={src}/>
            <p className="vjs-no-js">
                To view this video please enable JavaScript
            </p>
        </video>
    }
}


export default VideoForm
